import $ from 'static/script/libs/jquery';
import { toLocalizedRiotUrl } from 'tradera-apps/syi/script/app_react/utils/language';

let util = {};

util.redirectTo = function(url) {
    window.location.href = url;
};

util.serverLog = function(model) {
    $.ajax({
        type: 'POST',
        url: toLocalizedRiotUrl('/shopping/checkout2/clientlog/'),
        data: model
    });
};

export default util;
